/**
 * socket.ts — Shared Socket.io contract (task A05).
 *
 * Socket.io is a notification channel, NOT the source of truth (TODO.md §7).
 * One minimal server event (`game:changed`) plus client subscribe/
 * unsubscribe events. Secrets (assignments, tokens, keys) must never
 * appear in any of these payloads.
 */
import { z } from 'zod';

export const socketEvents = {
  client: {
    gameSubscribe: 'game:subscribe',
    gameUnsubscribe: 'game:unsubscribe',
  },
  server: {
    gameChanged: 'game:changed',
  },
} as const;

export const gameChangeReasonSchema = z.enum([
  'player_joined',
  'ready_changed',
  'wishlist_changed',
  'started',
  'ended',
]);
export type GameChangeReason = z.infer<typeof gameChangeReasonSchema>;

export const gameSubscribePayloadSchema = z.object({
  gameId: z.number().int().positive(),
});
export type GameSubscribePayload = z.infer<typeof gameSubscribePayloadSchema>;

export const gameSubscribeAckSchema = z.union([
  z.object({ ok: z.literal(true) }),
  z.object({ ok: z.literal(false), error: z.literal('FORBIDDEN') }),
]);
export type GameSubscribeAck = z.infer<typeof gameSubscribeAckSchema>;

/** Room format: `game:<gameId>` (see task G02). */
export function gameRoomName(gameId: number): string {
  return `game:${gameId}`;
}

export const gameChangedPayloadSchema = z.object({
  gameId: z.number().int().positive(),
  reason: gameChangeReasonSchema,
});
export type GameChangedPayload = z.infer<typeof gameChangedPayloadSchema>;
